<template>
    <b-modal id="AddTicketModal" modal-class="ticket_modal" centered size="lg" hide-footer
        hide-header-close >
        <template #modal-header class="modal-header-wrapper">
            <div class="text-center">
                <b-button variant="close-btn" class="btn-container" @click="closeModal">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>
        <b-container fluid>
            <h5 class="mb-1">
                <strong>New Ticket</strong>
            </h5>
            <p class="clr-bold-grey">
                Please fill the form below to submit your ticket.
            </p>
               <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="form-group row">
            <div class="col-md-12 mb-3">
              <input-text
                :vmodel.sync="form.phone"
                label-for="phone"
                labelName="Phone"
                input-class="custom-input mt-1"
                :rules="{ required: true }"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6 mb-3">
              <input-text
                :vmodel.sync="form.subject"
                label-for="subject"
                labelName="Subject"
                input-class="custom-input mt-1"
                :rules="{ required: true }"
              />
            </div>
            <div class="col-md-6 mb-3 category-selectwrapper">
              <input-multi-select
                :vmodel.sync="form.category_id"
                label-for="category"
                labelName="Category"
                :options="
                  categories.length ? categories.map((item) => item.id) : []
                "
                :custom-label="
                  categories.length
                    ? (id) => categories.find((item) => item.id == id).name
                    : () => {}
                "
                :active-data="categories"
                :rules="{ required: true }"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12 mb-3">
              <input-quill-editor
                :vmodel.sync="form.message"
                label="Message"
                :rules="{ required: true }"
                placeholder="Add your message here ..."
                formGroupClass ="editorInputWrapper"
              />
            </div>
          </div>
          <div class="form-group row uploadFilewrapper">
            <div class="col-12 col-lg-6">
              <input-file-multiple
                :vmodel.sync="form.issue_document"
                label-name="Upload Document"
                label-for="document"
                :rules="{ required: false }"
              >
                <template #uploadedFiles>
                
                </template>
              </input-file-multiple>
            </div>
              <span class="font-13 d-inline-block  clr-bold-grey upload-file-type"
                    >Allowed file types :
                    jpeg,png,jpg,gif,svg,pdf,xls,xlsx,doc,docx,csv & txt</span
                  >
          </div>
           <div class="button-wrapper d-flex justify-content-end mt-3 align-items-center gap-3">
                <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">
                    Cancel
                </button>
                <b-button class="univ-btn" type="submit">
                    Save
                </b-button>
            </div>
        </form>
      </ValidationObserver>
           
          
        </b-container>
    </b-modal>
</template>
<script>
import axios from "axios";
import InputQuillEditor from "@/components/form/InputQuillEditor";
import Helper from "@/resource/Helper";

const FORM = {
  email: "",
  first_name: "",
  last_name: "",
  phone: "",
  subject: "",
  message: "",
  user_type: "A", //for rep dashboard
  category_id: "",
  issue_document: [],
};
export default {
    name: "AddTicketModal",
     components: {
    InputQuillEditor,
  },
  data: () => ({
    form: {
      ...FORM,
    },
  }),
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
     closeModal() {
            this.$bvModal.hide("AddTicketModal");
        },

    submit() {
      let loader = this.$loading.show();
      const url = `${process.env.VUE_APP_TICKETING_URL}v1/tickets/send`;
      let headers = {
        'X-Ticketing-Token': Helper.ticketingToken(),
      };
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
        if (
          key == "issue_document" &&
          this.form.issue_document &&
          this.form.issue_document.length
        ) {
          formData.delete("issue_document"); //reset
          for (let i = 0; i < this.form.issue_document.length; i++) {
            formData.append(`${key}[${i}]`, this.form.issue_document[i]);
          }
        }
      }
      axios
        .post(url, formData, { headers })
        .then((res) => {
          this.$notify(res.data.message);
          this.$emit("onSuccess");
          this.resetForm();
          this.closeModal()
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error");
        })
        .finally(() => {
          loader.hide();
        });
    },
    resetForm() {
      const resetFields = {
        subject: "",
        message: "",
        category_id: "",
        issue_document: null,
      };
      Object.keys(resetFields).forEach((k) => {
        this.form[k] = resetFields[k];
      });
      this.$refs.observer.reset();
    },
    getUserDetails() {
      const [firstName, lastName] = this.$store.getters.rep.name.split(" ");
      this.form.email = this.$store.getters.rep.email;
      this.form.first_name = firstName;
      this.form.last_name = lastName;
      this.form.phone = this.validatePhone(this.$store.getters.rep.phone);
    },
    validatePhone(chars) {
      if(chars){
        return chars.replace(/\D/g, "");
      }
    },
  },
  mounted() {
    this.getUserDetails();
  },
   
   
};
</script>
<style scoped>
.univ-btn,
.cancel-btn {
    padding: 10px 26px;
    width: fit-content;
    font-size: 14px;
    margin: 0;
    border-radius: 6px;
}
</style>
